module.exports = __webpack_public_path__ + "assets/polish.232f6848ed2ed6df8c412778c954a941.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/polish.png
// module id = 626
// module chunks = 0